import T from '@wojtekmaj/react-t';

import {
  BackButton,
  ExtraButton,
  Title as HeaderWithButtonTitle,
  Wrapper,
} from './header_with_button.styles';

import Title from '../../title';

type HeaderWithButtonProps = {
  backButtonMode?: 'back' | 'up';
  children?: string;
  extraButton?: React.ReactNode;
};

export default function HeaderWithButton({
  backButtonMode,
  children,
  extraButton,
}: HeaderWithButtonProps) {
  return (
    <>
      <Title>{children}</Title>
      <Wrapper>
        <BackButton mode={backButtonMode} />
        <HeaderWithButtonTitle>
          <T>{children}</T>
        </HeaderWithButtonTitle>
        {extraButton ? <ExtraButton>{extraButton}</ExtraButton> : null}
      </Wrapper>
    </>
  );
}
